function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".spieler-2_svg__st0{fill:#c9b291}.spieler-2_svg__st2{fill:#545656}.spieler-2_svg__st8{fill:#dde539}.spieler-2_svg__st9{fill:#e0e0e0}.spieler-2_svg__st10{fill:#c44f4c}");

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  id: "spieler-2_svg__Ellipse_1",
  cx: 321.02,
  cy: 483.56,
  rx: 230.13,
  ry: 9.61,
  fill: "#f8f8f8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_165",
  className: "spieler-2_svg__st8",
  d: "M287.45 461.05s-1.02 7.17 2.39 12.29c3.41 5.12 4.44 8.53 6.83 9.21 2.39.68 18.77 0 18.77 0s3.75 3.07 4.44-2.39c.68-5.46 0-20.13 0-22.86s.3-15.7.3-15.7v-1.71s-8.84-4.09-10.88-5.12-6.83 0-6.83 0-2.39-6.83-2.05-12.29c.34-5.46 1.71-13.99 4.78-15.36l3.07-1.37s-3.07-4.78-7.51-4.78-10.87 2.73-13.45 6.48-2.92 11.95-1.9 14.33c1.02 2.39 3.75 11.6 3.75 11.6s-.34 8.87 0 11.95c.33 3.09-1.71 10.57-1.71 15.72z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_166",
  className: "spieler-2_svg__st9",
  d: "M302.52 406.78c2.67.34 8.48-1.71 8.48-1.71l5.12-2.73 4.06-6.83s5.16 26.96 8.23 28.67c3.07 1.71 13.65 9.56 13.65 9.56s-5.8 5.12-9.9 5.12-15.7 3.33-15.7 3.33l-21.5-6.4 7.56-29.01z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_167",
  className: "spieler-2_svg__st10",
  d: "M316.11 411.9s1.71 11.95 7.17 15.7c4.39 3.19 8.6 6.6 12.63 10.24 0 0 28.32-6.83 33.1-9.9 3-1.95 5.85-4.12 8.53-6.48 0 0-7.17 3.07-12.63 3.41s-19.79-6.83-21.5-7.85c-1.71-1.03-11.6-11.6-11.6-11.6l-5.46-9.9-2.05-3.75-4.13 3.75-4.06 6.83v9.55z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_168",
  className: "spieler-2_svg__st0",
  d: "M320.17 376.75l4.13 15.02s3.84 9.78 7.51 13.65c3.67 3.87 10.24 13.44 10.24 13.44l18.77 7.72 14.56-3.29s3.18.9 4.55-8.49c1.36-9.39 1.36-13.48 0-19.28-1.36-5.8-6.48-22.18-7.85-23.89s-11.26-18.09-11.26-18.09l-34.47 17.06-6.18 6.15z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_169",
  className: "spieler-2_svg__st9",
  d: "M306.9 365.83l15.18 17.85s7.34-7.17 9.39-8.93c2.05-1.76 19.09-11.66 19.09-11.66l10.26-9.56-4.44-9.9-17.06-15.02s-31.39 29.69-32.42 31.4c-1.03 1.73 0 5.82 0 5.82z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_170",
  className: "spieler-2_svg__st8",
  d: "M595.27 332.39l8.53 6.14 9.58 5.66s-7.1-11.53-7.09-20c.04-5.39.53-10.76 1.47-16.07l-10.47-2.69s3.7 3.41 4.6 7.17.21 13.31-2.17 14.33c-2.39 1.02-9.9 1.71-9.9 1.71l5.45 3.75z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_171",
  className: "spieler-2_svg__st9",
  d: "M514.05 307.13s13.31 8.87 21.5 9.21 25.25.59 30.72 3.71c5.46 3.12 12.97 6.87 15.36 7.21 2.39.34 8.19 1.36 8.19 1.36l13.99 2.05 1.37-20.13-7.89-3.41s-5.76-6.14-10.54-8.53c-4.78-2.39-20.13-13.65-20.13-13.65s-17.4-12.14-23.89-8.46c-6.49 3.68-4.78 3.68-4.78 3.68l-12.63-8.87-13.32-2.05v19.45l2.05 18.43z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_172",
  className: "spieler-2_svg__st10",
  d: "M472.41 294.51l13.99 2.39s10.58 6.14 11.95 6.48c1.37.34 6.48 1.36 8.53 2.05 2.05.68 7.17 1.71 7.17 1.71s8.19-6.48 10.58-12.63c2.39-6.14.68-23.21.68-23.21L512 266.18s-20.82-3.07-23.21-4.44c-2.39-1.37 1.02 12.63-1.71 17.75-2.72 5.12-14.67 15.02-14.67 15.02z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_173",
  className: "spieler-2_svg__st2",
  d: "M479.66 259.33l2.31 16.07s-6.83 10.92-9.56 11.26c-2.73.34-6.82 5.12-6.82 5.12l4.78 1.36 2.05 1.37 16.72-7.17s5.46-15.7 5.46-16.72-2.64-7.93-2.64-7.93l-12.3-3.36z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_174",
  className: "spieler-2_svg__st0",
  d: "M435.9 238.88s7.51 2.39 11.6 5.12l14.33 9.56s6.82 1.02 10.58 2.39 11.6 5.71 11.6 5.71 1.71 5.59 1.59 8.06c-.19 3.99-5.52 14.69-5.52 14.69l-5.17 9.04h-17.87l-30.37-2.34s-8.53-7.85-8.53-14.85c0-6.99.63-10.76 2.05-14.6 5.13-13.91 15.71-22.78 15.71-22.78z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_175",
  className: "spieler-2_svg__st0",
  d: "M169.03 83.94s-1.37 11.6 0 12.63c1.37 1.02-2.05 14.68-2.05 14.68s39.25 11.6 40.95 10.92 20.82-9.56 21.84-10.92c1.02-1.36-1.71-10.58-1.71-14.33s1.36-10.69 1.36-10.69l1.93-1.59v-7.39c0-.34 4.78-2.27 5.57-3.64.8-1.37 1.48-2.51-1.02-6.83s-4.09-7.39-3.87-8.87c.22-1.48-.68-3.64 1.71-6.94s-1.71-9.78-1.71-9.78-5.53-8.99-7.6-10.35c-2.07-1.37-15.72-11.95-15.72-11.95L186.2 30.36s-10.47 23.89-11.95 24-5.22 29.58-5.22 29.58z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_176",
  d: "M171.95 86.1l3.18.02-.55-20.02s-.4-7.74 3.81-8.05 8.2-1.2 10.23.75c2.03 1.95 3.95 4.24 4.28 6.17.33 1.94 6.93.61 6.93.61s-3.92-10.04-2.54-11.28 4.45-2.02 1.52-7.16-5.64-8-1.86-11.05c3.77-3.05 11.66-8.46 13.14-8 1.6.72 3.12 1.61 4.53 2.65 0 0-1.73 4.31-3.57 5.89a64.544 64.544 0 01-5.49 3.94s8.22-5.18 9.03-6.54c.81-1.36-.59 3.64-.03 5.12.56 1.48.63 8.54 3.58 9.92l2.95 1.38s-3.62-3.1-4.06-5.94c-.44-2.85-.6-11.95-.6-11.95l1.04-2.72 5.79 1.06 4.13 2.06s3.71-.64 3.2-8.95-8.54-16.66-9.67-16.9c-1.14-.23-10.11-2.91-15.68-2.61l-5.58.31 5.91.95-17.97-.9s-11.84 1.06-16.06 2.51-3.3.55-3.3.55l7.28-.29-12.88 3.56 5.57.26s-16.22 11.04-17.32 21.73-.8 16.94.31 21.16c1.11 4.22 9.9 16.67 10.47 17.7.56 1.03 4.82 11.29 6.06 11.98 1.27.69 1.03 2.06 4.22 2.08z",
  fill: "#836b33"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_177",
  className: "spieler-2_svg__st9",
  d: "M111.35 153.39s-.68-2.73 1.54-3.58c2.22-.85 13.65-11.09 13.65-11.09l10.24-10.92 2.22-5.6s1.54-2.59 2.22-2.59c1.07-.28 2.1-.68 3.07-1.2l7.17-3.75s4.95-1.02 5.63-1.36c.68-.34 6.48-5.29 7-5.46s-.17-5.12 5.46-3.75 19.96 5.29 19.96 5.29l9.56 4.78 14.85.17s3.58-4.44 4.78-4.95c1.2-.51 6.48-4.09 6.48-4.09s3.34-4.21 3.16-5.7.47-9.68.47-9.68l.64-3.68 1.93-1.59v-4.78s5.91 2.05 8.99 3.93c3.07 1.88 10.07 7.68 11.43 11.43 1.37 3.75 3.07 13.31 3.07 13.31v9.73s3.93 2.22 4.78 2.9c.85.68 6.32 8.36 6.32 8.36s7.17 7.85 7.68 10.75 0 4.09 0 4.09 3.24.85 3.75 2.05c.51 1.19 0 3.58 0 3.58s.34-1.02 2.05.17c1.11.85 1.99 1.96 2.56 3.24 0 0 1.37-1.54 2.56 0s2.39 5.63 2.39 5.63.34-3.07 4.95 1.2 5.12 8.7 5.12 8.7 5.12-2.22 6.31 1.02 5.63 9.04 5.63 9.04l12.11 5.12 8.7 8.02s5.8 1.19 8.02 1.88c2.22.68 8.7 4.78 9.39 4.95s12.97 5.63 12.97 5.63l11.95 7.17 13.31 3.43a80.446 80.446 0 0119.28 5.61c4.95 2.27 10.02 4.27 15.19 5.97l17.57 7.51 2.56 2.22 1.46 4.45s-4.79-3.41-8.35.61c-3.57 4.02-12.55 18.49-12.38 25.66.17 7.17-1.88 10.24 2.05 15.87s2.38 6.46 2.38 6.46l-15.35 17.6-20.31-1.02-32.59-.69-6.33.17 3.09 23.04s1.88 9.9 2.73 10.92c.85 1.02 2.9 10.57 2.9 10.57s-2.9-8.69-7.85-8.35c-4.95.34-39.76 23.21-39.76 23.21l-1.88 2.39 4.54 7.22 2.69 3.16s-14.06 2.08-17.47 1.74c-3.41-.34-9.9-2.73-9.38-3.07.51-.34-5.31-19.11-5.31-19.11v-16.89l.71-7.17-5.97-3.58.17-5.46-5.29-7.68s.17-4.95-.17-5.97c-.33-1.02-4.95-6.48-4.95-6.48l-5.97-3.24-7.17-8.36-9.38-7.51-3.75-9.04-.68-8.36-6.14-8.88-10.75-6.65-25.25-28.33-22.01-21.67-13.82-18.94-6.83-5.12-14.85-.18s-6.31 4.78-6.31 3.93 8.19-10.58 8.02-11.77c-.17-1.2 2.39-7.85-5.97-13.99-8.36-6.14-18.09-7.33-21.33-6.14-2.18.8-4.15 2.02-5.86 3.54z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_178",
  className: "spieler-2_svg__st10",
  d: "M162.37 117.56s5.29 5.8 6.31 9.56c1.02 3.75 1.88 13.82 1.88 13.82v10.58l5.12 1.36s20.31.34 23.38-1.54 14.33-4.44 18.94-4.27 21.33-4.27 23.21-3.24c1.88 1.02 4.95-9.73 7.51-12.11 2.56-2.39 10.58-9.52 10.58-9.52l.34-1.05-4.78-2.9-.22-10.94S247.7 93 244.8 90.27a9.49 9.49 0 00-5.97-2.73l-4.27 10.07-6.48 12.45-11.78 12.14-18.94 1.34-12.63-.34-8.87-.17-6.83-3.75-6.66-1.72z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_179",
  className: "spieler-2_svg__st2",
  d: "M161.18 176.88c.68-.23 4.09-1.14 4.09-1.14l11.38 15.02 24.12 22.07 12.06 14.56 6.88 6.2 4.18 5.12s2.65 4.61 3.93 5.55 8.36 9.56 8.36 9.56l2.56 4.18s6.4 4.89 6.63 7.17c.23 2.27-2.27 10.75-2.27 10.75l-1.65-9.75-2.67-5.78-10.24-9.78-14.11-14.56-12.51-12.97-5.23-7.89-10.46-8.95-10.47-10.01-4.78-7.51-9.8-11.84z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_180",
  className: "spieler-2_svg__st2",
  d: "M289.26 335.91l5.69 10.92 5.92 11.38 3.87 6.37 9.79-6.15s10.92-7.96 13.88-8.19c2.96-.23 12.51-5.69 12.51-5.69l8.19-2.05 7.28 1.14 2.58 5.04-16.92 1.56-21.88 6.82-9.51 9.19s-14.35 5.37-13.44 7.42c.91 2.05 14.33 0 14.33 0l1.85-.58 3.62 4.65-10.59 1.77-13.59-1.77-2.67-1.34 3.87-3.64 3.41-5.23-6.82-9.82-5.77-8.83v-5.92l4.56 7.08 3.94 6.11 5.46 8.42 2.27 2.05 1.42-.68-15.98-24.8-1.23-5.23.26-2.67 3.7 2.67z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_181",
  className: "spieler-2_svg__st2",
  d: "M438.58 235.86s-15.87 10.39-20.42 23.47c-4.55 13.08-14.56 30.29-14.56 30.29s-.75 17.17 1.6 17.29c2.34.12 11.37-5 11.37-5s8.62-6.37 10.92-8.47c2.3-2.1 1.71-3.02 1.71-3.02l-6.48-.57-13.65 13.08s-3.41 1.71-3.53-.8c-.11-2.5 0-13.08 1.48-15.36s20.22-42.5 24.96-44c4.73-1.5 8.45-2.27 9.49-1.83 1.05.44 0-3.54 0-3.54l-2.89-1.54z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_182",
  className: "spieler-2_svg__st2",
  d: "M144.28 118.41l1.02 3.78-1.02 3.04-5.12 5.8-3.07 4.09h3.24l2.73-2.73c1.2-1.19 5.46-8.02 5.8-8.53.34-.51 2.35-4.27 2.35-4.27l-5.93-1.18z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_183",
  className: "spieler-2_svg__st2",
  d: "M148.95 115.97c.26-.14 3.18 2.45 3.18 2.45v3.78l-1.91 2.02 5.5-4-1.2-4.25h-3.24l-3.01.36"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_184",
  className: "spieler-2_svg__st0",
  d: "M39 185.07l5.01-.91h5.69s-.45-1.59 2.05-1.82c2.5-.23 9.1 0 9.1 0l9.1 1.31 5.69-3.82s4.55-8.65 11.38-11.6 20.93-12.06 21.61-12.29 8.87-4.78 8.87-4.78l5.87-1.53s8.92-1.75 11.88 0 11.38 12.9 11.38 12.9l-7.2 14.85-6.91 6.53-11.15 2.96-10.11 8.65s-9.91 2.73-16.96 2.73H82s-3.19 6.6-7.05 7.05c-3.87.45-8.19 1.82-9.1 1.37-.91-.45-8.19-2.27-8.19-2.27l-2.73 1.14v3.18s-3.64 1.59-5.01 0a59.872 59.872 0 00-4.55-4.32l-1.14-5.92.23-2.51-4.09-.91-1.37-2.94s-1.66-6.74 0-7.05z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_185",
  className: "spieler-2_svg__st2",
  d: "M303.74 334.61s-3.58 2.56-2.9 6.4c.68 3.84 6.14 12.37 12.54 10.41 4.99-1.44 8.2-6.28 7.59-11.43-.51-3.5-2.65-8.45-6.31-8.96-4-.65-8.07.69-10.92 3.58z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_186",
  className: "spieler-2_svg__st2",
  d: "M298.54 332.47v1.71l-.68.94h1.02l.34 1.54.6-1.71h.94l-.77-1.11v-1.36l-.68.77-.77-.78z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_187",
  className: "spieler-2_svg__st2",
  d: "M303.23 328.21l-.3 1.66-.64 1.01.94.4v1.19l.94-1.11 1.45-.49-1.11-.92.56-1.67-1.11.69-.73-.76z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_188",
  className: "spieler-2_svg__st2",
  d: "M309.46 325.65l-.43 1.28-.94.81.81.85v.85l.81-1.02 1.96.51-.6-1.19.6-1.28-1.79.04-.42-.85z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "spieler-2_svg__Pfad_11",
  d: "M653.99 276.71c-23.94-2.4-45.29 15.06-47.69 39-1 10.03 1.5 20.09 7.08 28.48-2.39 10.55-11.5 16.61-11.5 16.61s13.11 4.58 23.32-3.77c.21-.17.41-.34.61-.51 20.14 13.16 47.14 7.49 60.3-12.65 13.16-20.14 7.49-47.14-12.65-60.3a43.8 43.8 0 00-19.47-6.86h0z",
  fill: "none",
  stroke: "#e0e0e0",
  strokeWidth: 2.835,
  strokeMiterlimit: 10
});

function SvgSpieler2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spieler-2_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 700 500",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
}

export default __webpack_public_path__ + "static/spieler-2.ceba0895.svg";
export { SvgSpieler2 as ReactComponent };